export const ENV = process.env.REACT_APP_ENV || 'prod';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api/v1';
export const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || 'ws://localhost:8080/ws';

// Verifica se está em modo de desenvolvimento/homologação
export const USE_MOCK = ENV === 'dev' || ENV === 'hml';
